module.exports = __webpack_public_path__ + "assets/img/101411.120e1998.png";